import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
import { heroImage, siteInfo } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative h-screen min-h-[680px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Horseback riding in the Swedish mountains"
          className="w-full h-full object-cover hero-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60" />
      </div>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col justify-end pb-24 md:pb-32">
        <div className="max-w-3xl">
          <p className="text-[#e8d8b4] text-[11px] md:text-xs uppercase tracking-[0.4em] mb-6 font-medium">
            Ljungdalsfjällen · Jämtland · Sweden
          </p>
          <h1 className="font-display text-[#faf7f2] text-5xl md:text-7xl lg:text-[88px] leading-[0.98] mb-8">
            Där vägen tar slut <br />
            <em className="italic font-light text-[#e8d8b4]">börjar vår.</em>
          </h1>
          <p className="text-[#e8e1d2] text-base md:text-lg max-w-xl leading-relaxed mb-10 font-light">
            {siteInfo.tagline}. Upplev lugnet, vyerna och hästens takt genom ett av Sveriges vackraste fjällandskap.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="#ridturer" className="btn-primary">
              Utforska ridturer <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a
              href="#kontakt"
              className="inline-flex items-center gap-2 px-6 py-[0.85rem] border border-[#faf7f2]/70 text-[#faf7f2] hover:bg-[#faf7f2] hover:text-[#2f3d30] transition-colors font-medium tracking-wide text-sm"
            >
              Boka din tur
            </a>
          </div>
        </div>
      </div>

      <a
        href="#om-oss"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#faf7f2] text-xs uppercase tracking-[0.3em] flex flex-col items-center gap-2 animate-bounce-slow"
      >
        <span>Scrolla</span>
        <ArrowDown className="w-4 h-4" strokeWidth={1.5} />
      </a>
    </section>
  );
};

export default Hero;
